import React, { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNetworkState } from 'react-use';
import cn from 'classnames';
import { AppDispatchActions } from 'src/redux/actions';
import { Element } from 'src/components';

export function NetWorkUI() {
    const dispatch = useDispatch();
    const netWork = useNetworkState();
    
    useEffect(() => {
        if (typeof netWork.online !== 'undefined') {
            dispatch(AppDispatchActions.isOnlineUpdate(netWork.online));
        }
    }, [netWork]);

    return (
        <>
            {netWork.online === false && (
                <Element
                    className={cn(
                        'fixed z-[200] bottom-0',
                        'p-[5px]',
                        'w-full',
                        'text-white',
                        'bg-black'
                    )}
                >
                    <span>
                        Không thể kết nối đến máy chủ. Vui lòng kiểm tra đường
                        truyền
                    </span>
                </Element>
            )}
        </>
    );
}

export default memo(NetWorkUI);
